module.exports = __webpack_public_path__ + "static/hero-pay-it-faster-05e38056824d4d6e918298ace80b40cd.webp";